import { AudioTrack, Playlists } from "./types";

export const ALL_PLAYLISTS = [
	"LAKESIDE",
	"FIREPLACE",
	"CAT",
	"DOOR_OPEN",
	"RADIO_GUITAR_LOFI_01",
	"RADIO_GUITAR_LOFI_02",
	"RADIO_GUITAR_LOFI_03",
	"RADIO_GUITAR_LOFI_04",
	"RADIO_GUITAR_LOFI",
	"RADIO_TEST",
	"PLANE",
	"OCEAN",
	"BIRD_AMBIENT",
] as const;

export const PLAYLIST = Object.freeze({
	LAKESIDE: [{ source: "audio/int-cabin-window01_v01.mp3", defaultGain: 1 }],
	FIREPLACE: [
		{
			source: "audio/fireplace-treble_v01.mp3",
			defaultGain: 1,
		},
	],
	CAT: [{ source: "audio/mus-cabin-cat2_v01.mp3", defaultGain: 0.1 }],
	DOOR_OPEN: [{ source: "audio/sfx-door-wood-close-01_v01.mp3", defaultGain: 0.1 }],
	RADIO_GUITAR_LOFI_01: [
		{
			source: "audio/guitar-lofi-01_v01.mp3",
			defaultGain: 0.5,
		},
	],
	RADIO_GUITAR_LOFI_02: [
		{
			source: "audio/guitar-lofi-02_v01.mp3",
			defaultGain: 0.2,
		},
	],
	RADIO_GUITAR_LOFI_03: [
		{
			source: "audio/guitar-lofi-03_v01.mp3",
			defaultGain: 0.2,
		},
	],
	RADIO_GUITAR_LOFI_04: [
		{
			source: "audio/guitar-lofi-04_v01.mp3",
			defaultGain: 0.2,
		},
	],
	RADIO_GUITAR_LOFI: [
		{
			source: "audio/guitar-lofi-01_v01.mp3",
			defaultGain: 0.5,
		},
		{
			source: "audio/guitar-lofi-02_v01.mp3",
			defaultGain: 0.2,
		},
		{
			source: "audio/guitar-lofi-03_v01.mp3",
			defaultGain: 0.2,
		},
		{
			source: "audio/guitar-lofi-04_v01.mp3",
			defaultGain: 0.2,
		},
	],
	RADIO_TEST: [
		{
			source: "audio/track01-sinclair_v01.mp3",
			defaultGain: 0.4,
		},
		{
			source: "audio/track02-sinclair_v01.mp3",
			defaultGain: 0.4,
		},
		{
			source: "audio/track03-sinclair_v01.mp3",
			defaultGain: 0.4,
		},
		{
			source: "audio/track04-sinclair_v01.mp3",
			defaultGain: 0.4,
		},
		{
			source: "audio/track05-sinclair_v01.mp3",
			defaultGain: 0.4,
		},
	],
	PLANE: [
		{
			source: "audio/trvl-carib-plane01_v01.mp3",
			defaultGain: 0.3,
		},
	],
	OCEAN: [
		{
			source: "audio/trvl-carib-ocean-01_v01.mp3",
			defaultGain: 0.4,
		},
	],
	BIRD_AMBIENT: [
		{
			source: "audio/bird-ambient_v01.mp3",
			defaultGain: 1,
		},
	],
}) satisfies Record<Playlists, AudioTrack[]>;
